export const directorySteps = ()=>{
return[
  {
    target: '[data-tour="dir-comp"]',
    title: "📁 Directory Dashboard",
    content: "Welcome to the Directory Dashboard. Here you can view and manage all employee records in one place.",
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-bar-dir"]',
    title: "🔍 Search Users",
    content: "Use this search bar to quickly find employees by name, email, or other details.",
    disableBeacon: true,
  },
  {
    target: '[data-tour="filter-dep"]',
    title: "🏢 Department Filter",
    content: "Filter employees based on their department to narrow down your search results.",
    disableBeacon: true,
  }
];
}